class HHContactForm extends HTMLElement {
  constructor() {
    super()

    this.forms.forEach(form => {
      this.disableRecaptcha(form)
      form.addEventListener('submit', this.onSubmit.bind(this))
    })
  }

  onSubmit(event) {
    const form = event.target
    const requiredFields = form.querySelectorAll('.js-field.required')
    let formValid = true

    this.clearForm(form)

    requiredFields.forEach((field) => {
      let fieldValid = true
      const input = field.querySelector('input') || field.querySelector('textarea')
      if (!input) return false
      const inputType = input.getAttribute('type')

      if (!input.value) {
        field.querySelector('.js-error__required')?.classList.remove('hidden')
        formValid = false
        fieldValid = false
      }

      if (inputType == 'email' && !this.validEmailAddress(input.value)) {
        field.querySelector('.js-error__valid')?.classList.remove('hidden')
        formValid = false
        fieldValid = false
      }

      if (!fieldValid) {
        field.classList.add('form-wrapper__with-errors')
      }
    })

    if (!formValid) {
      event.preventDefault()
      form.querySelector('.js-form-errors')?.classList.remove('hidden')
      event.preventDefault()
    }
  }

  disableRecaptcha(form) {
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && (mutation.target.getAttribute('onsubmit'))) {
          mutation.target.setAttribute('onsubmit', '')
        }
      });
    });

    observer.observe(form, {
      attributes: true
    });
  }

  validEmailAddress(value) {
    return value.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)
  }

  clearForm (form) {
    form.querySelectorAll('.js-form-errors, .js-error__valid, .js-error__required').forEach(element => {
      element.classList.add('hidden')
    })

    form.querySelectorAll('.js-field').forEach(element => {
      element.classList.remove('form-wrapper__with-errors')
    })
  }

  get forms() {
    return this.querySelectorAll('form')
  }
}

customElements.define('hh-contact-form', HHContactForm)
